export default __webpack_public_path__ + "images/c2570a53debe5d561684badff1e76311.png";